const RETURN_TO_BASE = "https://app.leadx.invalid";
const MAX_RETURN_TO_LENGTH = 2_048;

export function safeLocalReturnTo(value: unknown): string | null {
	const candidate = Array.isArray(value) ? value[0] : value;
	if (typeof candidate !== "string") return null;
	if (
		candidate.length === 0 ||
		candidate.length > MAX_RETURN_TO_LENGTH ||
		!candidate.startsWith("/") ||
		candidate.startsWith("//")
	) {
		return null;
	}

	try {
		const parsed = new URL(candidate, RETURN_TO_BASE);
		if (parsed.origin !== RETURN_TO_BASE || parsed.hash) return null;
		return `${parsed.pathname}${parsed.search}`;
	} catch {
		return null;
	}
}
